import {useContext} from 'react';
import ProfileContextMobile from '../contextCreate/ProfileContextMobile';

const useProfile = () => {
	return useContext(ProfileContextMobile);
};

export default useProfile;
